import React, { useContext } from 'react';
import { AppConfigContext } from '../Config/App';

const Logo = ({ classes }) => {
    const { assets_url } = useContext(AppConfigContext)

    return (
        <img loading="lazy" alt="Pokeland Legends Builder" className={`img-fluid ${classes}`} src={assets_url('pokeland_legends_club_logo.webp')}></img>
    );
}
export default Logo;